const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} Mapping of experiment keys to Variant objects
 */
export function getAmplitudeExperimentKeyToVariantMap() {
    return ChairishContext.AMPLITUDE_EXPERIMENT_KEY_TO_VARIANT_MAP;
}

/**
 * @returns {Object} Mapping of experiment bucket keys to values
 * @example {A: 'control', B: 'treatment'}
 */
export function getAmplitudeExperimentBucketMap() {
    return ChairishContext.AMPLITUDE_EXPERIMENT_BUCKET_MAP;
}

/**
 * @returns {Object} Mapping of experiment flag keys to values
 * @example {EXAMPLE_FLAG: 'example-flag'}
 */
export function getAmplitudeExperimentFlagMap() {
    return ChairishContext.AMPLITUDE_EXPERIMENT_FLAG_MAP;
}

/**
 * @returns {Array.<string>} List of experiment flag keys from the server to expose to the client
 */
export function getExposeExperimentFlags() {
    return ChairishContext.EXPOSE_EXPERIMENT_FLAGS || [];
}

/**
 * @param {string} flagKey The key of the experiment flag to check
 * @returns {boolean} True if the user should be exposed to the experiment, false otherwise
 */
export function shouldExposeExperiment(flagKey) {
    return getExposeExperimentFlags().includes(flagKey);
}
